import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from '../../../Services/account.service'
import { CommunicationModel, EmailPopupModel, PasswordResetRequest, PopupButton, PopupModel, PopupModelReturn, User_Login } from '../../../AllTableClasses';
//import { LoadingService } from '../../../services/loading.service';
import { waitForAsync } from '@angular/core/testing';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { NotificationPopupComponent } from '../../Components/notification-popup/notification-popup.component';
import { EmailPopupComponent } from '../../Components/email-popup/email-popup.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  public submitted: boolean = false;
  public request: PasswordResetRequest = new PasswordResetRequest()
  public username: string = '';

  constructor(private accountService: AccountService,
    private router: Router,
    private popupNotificationService: PopupNotificationService
    //private toast: ToastrService
    //private loadingService: LoadingService
  ) { }

  public CancelRequest() {
    this.router.navigate(['login']);
  }

  public formSubmit(f: NgForm) {

    this.submitted = true;
    this.request.MessageFormat = 'SMS';
    if (!f.invalid) {

      this.accountService.ForgotPasswordRequestSet(this.request, (data) =>
      {
        if (data.Success) {
          this.popupNotificationService.showNotifcation('success', 'Password Reset Request Successfully Submitted');
        }
        else
        {
          this.popupNotificationService.showNotifcation('error', data.UserErrorMessage);
        }
      }, (error) => { });

    }

  }
}
